import { render, staticRenderFns } from "./MPCFooter.vue?vue&type=template&id=4601794d&scoped=true&"
import script from "./MPCFooter.vue?vue&type=script&lang=js&"
export * from "./MPCFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4601794d",
  null
  
)

export default component.exports